export const cardAdapter = (card) => ({
  id: card.id,
  brand: card.data.brand,
  number: `**** **** **** ${card.data.number}`,
  isActive: card.is_default,
});
